module.exports = __webpack_public_path__ + "static/images/banner.9e67652.jpg";